// Lista de sugerencias / correccion de direccion bajo la casilla de la calle
// en la ficha del cliente (Lissette, 2026-09-25: "necesito agregar el corrector
// o sugerencia de direcciones"). El servidor decide el proveedor — ver
// deskte-api/src/utils/addressSuggest.ts.
//
// Solo PROPONE: nada cambia en la ficha hasta que la persona pulsa una
// sugerencia. Solo pregunta cuando `enabled` (la persona ha tecleado en la
// direccion), nunca al abrir una ficha ya guardada.
import { useEffect, useRef, useState } from 'react';
import { suggestAddresses } from '../api.js';

const PAUSA_MS = 450;
const norm = (s) => String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');

export function AddressSuggestions({ query, enabled, onPick, lang }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const turno = useRef(0);
  const { street = '', city = '', state = '', zip = '' } = query || {};

  useEffect(() => {
    const mio = ++turno.current;
    if (!enabled || street.trim().length < 3) { setItems([]); setOpen(false); return undefined; }
    const t = setTimeout(async () => {
      const list = await suggestAddresses({ street, city, state, zip });
      // Solo cuenta la respuesta de la ULTIMA pregunta: una lenta que llega
      // tarde no puede tapar lo que la persona ya ha seguido escribiendo.
      if (mio !== turno.current) return;
      const actual = norm([street, city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', '));
      // Si la unica propuesta es exactamente lo que ya esta escrito, no hay
      // nada que corregir: no se molesta.
      const utiles = list.filter((s) => norm(s.label) !== actual);
      setItems(utiles);
      setOpen(utiles.length > 0);
    }, PAUSA_MS);
    return () => clearTimeout(t);
  }, [enabled, street, city, state, zip]);

  if (!open || items.length === 0) return null;
  const es = lang === 'es';
  return (
    <div role="listbox" style={{
      marginTop: '.25rem', border: '1px solid var(--c-border,rgba(0,212,255,.25))', borderRadius: 9,
      background: 'var(--c-surface,#0b1a2a)', overflow: 'hidden',
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '.4rem .75rem', fontSize: '.6rem', fontWeight: 800, textTransform: 'uppercase',
        letterSpacing: '.08em', color: 'var(--c-text2,#7aa3c0)',
      }}>
        <span>📍 {es ? '¿Quisiste decir…?' : 'Did you mean…?'}</span>
        <button type="button" onClick={() => setOpen(false)} aria-label={es ? 'Cerrar sugerencias' : 'Close suggestions'}
          style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontSize: '.8rem' }}>✕</button>
      </div>
      {items.map((s) => (
        <button key={s.label} type="button" role="option" aria-selected="false"
          onClick={() => { setOpen(false); onPick(s); }}
          style={{
            display: 'block', width: '100%', textAlign: 'left', padding: '.5rem .75rem',
            background: 'none', border: 'none', borderTop: '1px solid var(--c-border,rgba(0,212,255,.12))',
            color: 'var(--c-text,#e6f1ff)', fontSize: '.8rem', cursor: 'pointer',
          }}>
          {s.label}{s.county ? <span style={{ color: 'var(--c-text2,#7aa3c0)' }}> · {s.county}</span> : null}
        </button>
      ))}
    </div>
  );
}
